import axios from "../utils/axios";
// redux/api/userApi.js
// User (Customer) API calls


const API_URL = "api/users";


// ══════════════════════════════════════════════════════════════════
// USER AUTH APIs
// ══════════════════════════════════════════════════════════════════

export const registerUserApi = async (userData) => {
  const { data } = await axios.post(`${API_URL}/user/register`, userData);
  return data;
};

export const loginUserApi = async (credentials) => {
  const { data } = await axios.post(`${API_URL}/user/login`, credentials);
  return data;
};

export const getUserProfileApi = async () => {
  const { data } = await axios.get(`${API_URL}/user/profile`);
  return data;
};

export const updateUserProfileApi = async (updates) => {
  const { data } = await axios.put(`${API_URL}/user/profile`, updates);
  return data;
};

// ══════════════════════════════════════════════════════════════════
// ADDRESS APIs
// ══════════════════════════════════════════════════════════════════

export const addAddressApi = async (addressData) => {
  const { data } = await axios.post(
    `${API_URL}/user/address`,
    addressData
  );
  return data;
};

export const deleteAddressApi = async (addressId) => {
  const { data } = await axios.delete(
    `${API_URL}/user/address/${addressId}`
  );
  return data;
};

// ══════════════════════════════════════════════════════════════════
// RESTAURANT TRACKING APIs
// ══════════════════════════════════════════════════════════════════

export const trackRestaurantVisitApi = async (restaurantId) => {
  const { data } = await axios.post(
    `${API_URL}/user/track-visit/${restaurantId}`
  );
  return data;
};

export const getVisitedRestaurantsApi = async () => {
  const { data } = await axios.get(
    `${API_URL}/user/visited-restaurants`
  );
  return data;
};